module.exports = __webpack_public_path__ + "static/doctype2-2b608f416da790f06c33fed5912817f8.jpg";